import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { ICondition } from '../../interfaces/condition.interface';

export class EnergyManagementPlugin extends SmartenitPlugin
  implements ICondition {
  public getConditionOptions(): any {
    return null;
  }

  public getConditionAttribute(): string {
    return 'PeriodCost';
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    return this.state;
  }
}
